import React from 'react';
import { IconClock, IconRefreshCw, IconTarget, IconSparkles } from 'src/icons';

interface StatusBarProps {
  lastUpdated: Date | null;
  refreshing: boolean;
  engagementRate: number;
  newUsersThisWeek: number;
}

export function StatusBar({
  lastUpdated,
  refreshing,
  engagementRate,
  newUsersThisWeek,
}: StatusBarProps) {
  return (
    <div className="flex flex-wrap justify-between items-center gap-1 mb-0.5 shrink-0">
      <div className="flex items-center gap-1 min-w-0">
        {lastUpdated && (
          <span className="flex items-center gap-0.5 text-[10px] text-gray-500">
            <IconClock className="w-2.5 h-2.5 shrink-0" />
            {lastUpdated.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
          </span>
        )}
        {refreshing && (
          <span className="flex items-center gap-0.5 text-[10px] text-blue-600">
            <IconRefreshCw className="w-2.5 h-2.5 animate-spin shrink-0" />
            Updating…
          </span>
        )}
      </div>
      <div className="flex items-center gap-1">
        <span className="bg-green-50 px-1 py-0.5 rounded text-[10px] text-green-700">
          <IconTarget className="inline w-2.5 h-2.5 align-middle shrink-0" /> {engagementRate ?? 0}%
        </span>
        <span className="bg-blue-50 px-1 py-0.5 rounded text-[10px] text-blue-700">
          <IconSparkles className="inline w-2.5 h-2.5 align-middle shrink-0" /> +{newUsersThisWeek}
        </span>
      </div>
    </div>
  );
}
